<template>
    <div class="page_coupon">
        <div class="list" v-if="dataList.length!=0">
            <div class="item_wrap" v-for="(item,key) in dataList" :key="item.id">
                <div :class="item.status == 0 ? 'item' : 'item used'">
                    <div class="item_l">
                        <div class="item_l_con">
                            <div class="cash" v-if="item.note_id != 3 && item.note_id != 4"><span class="tag_cash">¥</span>{{item.locationnote.money}}</div>
                            <div class="tips">{{item.note_id == 1 ? ( item.locationnote.full != null ? ( '满' + item.locationnote.full + '减' + item.locationnote.money ) : '') : ''}}{{item.note_id == 2 ? '现金券' : ''}}{{item.note_id == 3 ? ( item.locationnote.rebate != null ? ( '打' + item.locationnote.rebate + '折' ) : '') : ''}}{{item.note_id == 4 ? '实物券' : ''}}</div>
                        </div>
                    </div>
                    <div class="item_r">
                        <div class="item_r_t">{{item.title}}</div>
                        <div class="item_r_b">
                            <div class="time">{{item.created_at}}</div>
                            <!-- <div class="action" v-if="item.status">去使用</div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="item used">
                <div class="item_l">
                    <div class="cash"><span class="tag_cash">¥</span>5</div>
                    <div class="tips">满30元可用</div>
                </div>
                <div class="item_r">
                    <div class="item_r_t">实付金额 满30元 可用（2天到期）</div>
                    <div class="item_r_b">
                        <div class="time">2020.03.01-2020.03.31</div>
                        <div class="action">去使用</div>
                    </div>
                </div>
            </div> -->
        </div>
		<!-- 无优惠券 -->
		<div class="page_kaifa" v-if="dataList.length==0">
			<div class="top">
				<img :src="publicPath+'statics/images/devolping.png'" alt="" class="tu">
			</div>
			<div class="tips">
				<div class="sub_txt">暂无优惠券</div>
			</div>
		</div>
    </div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    name: "my-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            dataList: [],
            token: ''
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的优惠券'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.getData();
        }
        // 获取列表
        // this.getData();
    },
    methods: {
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var token = this.token;
            var param = {
                token: this.token,
                page: 1,
                size: 50
            };
            this.$api.my.couponList(param).then(res=>{
                if (res.code == 200) {
                    var list = res.result
                    console.log(list)
                    this.dataList = list
                } else {
                    this.$toast(res.message)
                }
            })
        },

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
